<template>
     <el-container class="home-container">

        <el-header style="text-align: right; font-size: 12px;">
            <div>
                <img src="../../assets/logo1.png"/>
                <span style="font-size:25px;">构建系统</span>
                
            </div>
            <div>
                
                <span style="font-size:14px;">{{user.userRealName}}&nbsp;&nbsp;&nbsp;</span>
                <el-button type="text" icon="el-icon-user" style="margin-right: 15px;color:#eee;font-size:14px;" @click="logout">退出登录</el-button>
            </div>
        </el-header>

        <el-container style="height: 0; border: 1px solid #eee">
            <el-main>
                <router-view></router-view>
            </el-main>
        </el-container>
    </el-container>
</template>

<script>
    
    export default {
        name:'Home',
        data() {
            var validatePassword = (rule, value, callback) => {
                if(value) {
                    let reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[a-zA-Z0-9]{8,20}$/
                    if(!reg.test(value)) {
                        callback(new Error("密码必须包含字母和数字，长度为8-20位"));
                    }
                }
                callback();
            };
            return {
                updateUser: {},
                rules: {
                    password: [
                        { required: true, message: '请输入密码', trigger: 'blur' },
                        { validator: validatePassword, trigger: 'blur' }
                    ]
                },
                user: {},
                isCollapse: true,
                dialogFormVisible: false,
                isDisabled: false,
                isShowMyOrderInfo: true,
            }
        },
        methods: {
            updatePassword() {
                var formName = 'updateUser';
                this.dialogFormVisible = true;
                this.$refs[formName].resetFields();
            },
            doUpdatePassword(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.$axios.post("/login/updatePassword",this.updateUser).then(
                            res=>{
                                if(res.data.status === "success"){
                                    this.$message.success("密码修改成功！");
                                    this.dialogFormVisible = false;
                                } else {
                                    this.$message.error(res.data.message);
                                }
                            },
                            error=>{
                                this.$message.error(error.message);
                            }
                        )
                    } else {
                        return false;
                    }
                });
                
            },
            logout() {
                this.$axios.post("/login/logout").then(
                    res=>{
                        if(res.data.status === "success"){
                            window.localStorage.removeItem("user");
                            window.localStorage.removeItem("userId");
                            this.$router.push("/loginMobile");
                            
                        } else {
                            this.errorMsg = res.data.message;
                        }
                    },
                    error=>{
                        this.$message.error(error.message);
                        this.$router.push("/loginMobile");
                    }
                )
            }

        },
        created() {
            this.$router.push("/mobile/orderInfo");
        },
        mounted() {
            this.user = JSON.parse(window.localStorage.getItem("user"));
            if(this.user.roleCode === 'ADMIN') {
                 this.isDisabled = true;
            }
            if(this.user.roleCode === 'PUBLIC' || this.user.roleCode === 'CLOCK') {
                 this.isShowMyOrderInfo = false;
            }
        }
        
    }


</script>

<style lang="less" scoped>
    .home-container {
        position:absolute;
        height: 98%;
        width: 100%;
    }
    .el-header {
        background-color: #545c64;
        color: rgb(242, 245, 247);
        line-height: 20px;
        display: flex;
        justify-content: space-between;
        padding-left: 0;
    }

    .el-header div {
        display: flex;
        align-items: center;
    }
    
    .el-aside {
        color: #333;
    }
    .el-main {
        width: 99%;
    }

    
</style>
